import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useState } from "react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <motion.div
      className="max-w-2xl mx-auto text-bold"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.65, delay: 0.35, ease: "easeInOut" }}
    >
      <header className="max-md:left-20 bg-blend-hard-light max-md:bottom-3 relative shadow-lx shadow-cyan-500/30 hover:shadow-cyan-500/40 hover:shadow-lg duration-700 ease-in-out backdrop-blur-sm flex justify-between items-center max-w-fit lg:min-w-fit lg:fixed z-[5000] top-5 inset-x-0 mx-auto lg:px-8 py-3 sm:px-4 rounded-lg border-2 border-transparent dark:border-transparent light:border-gray-200 dark:bg-gray-900/70 bg-gray-900/10 dark:text-white light:text-black">
        {/* Hamburger menu button - only visible on mobile */}
        <button
          className="md:hidden flex flex-col justify-center items-center m-2 w-6 h-4 space-y-1 "
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span
            className={`block w-6 h-0.5 bg-current transform transition duration-300 ${
              isMenuOpen ? "rotate-45 translate-y-1.5" : ""
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-current transition duration-300 ${
              isMenuOpen ? "opacity-0" : "opacity-100"
            }`}
          ></span>
          <span
            className={`block w-6 h-0.5 bg-current transform transition duration-300 ${
              isMenuOpen ? "-rotate-45 -translate-y-1.5" : ""
            }`}
          ></span>
        </button>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-5 font-bold">
          <Link
            to={"/"}
            className="text-lg hover:drop-shadow-[0_0_8px_#000000] transition-all duration-1000"
          >
            Work
          </Link>
          <Link
            to="/Contact"
            className="text-lg hover:drop-shadow-[0_0_8px_#000000] transition-all duration-1000"
          >
            Contact
          </Link>
          <Link
            to="/ToS"
            className="text-lg hover:drop-shadow-[0_0_8px_#000000] transition-all duration-1000"
          >
            Terms
          </Link>
        </nav>

        {/* Mobile Navigation - Dropdown menu */}
        {isMenuOpen && (
          <div className="absolute top-full left-0  right-0 min-w-fit mt-2 p-4 rounded-lg shadow-lg md:hidden  backdrop-blur-sm">
            <nav className="flex flex-col space-y-3 font-bold">
              <Link
                to={"/"}
                className="text-lg hover:drop-shadow-[0_0_8px_#000000] transition-all duration-700"
                onClick={() => setIsMenuOpen(false)}
              >
                Work
              </Link>
              <Link
                to="/Contact"
                className="text-lg hover:drop-shadow-[0_0_8px_#000000] transition-all duration-700"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              <Link
                to="/ToS"
                className="text-lg hover:drop-shadow-[0_0_8px_#000000] transition-all duration-700"
                onClick={() => setIsMenuOpen(false)}
              >
                Tos
              </Link>
            </nav>
          </div>
        )}
      </header>
    </motion.div>
  );
};

export default Header;
